
import TextField from './TextField';
import EmailField from './EmailField';
import UrlField from './UrlField';
import SectionHeader from './SectionHeader';
import Instruction from './Instruction';
import CheckboxField from './CheckboxField';
import RadioField from './RadioField';
import SelectField from './SelectField';
import TextareaField from './TextareaField';
import DateField from './DateField';
import TimePickerField from './TimePickerField';
import FileField from './FileField';
import RichTextInstructionField from './RichTextInstructionField';
import { StudentSearchField } from './student-search';
import { TeacherSearchField } from './teacher-search';
import PreviousReportButton from './PreviousReportButton';
import WorksheetSearchField from './WorksheetSearch';
import DocumentLinkField from './DocumentLinkField';

// Export all components
export {
  TextField,
  EmailField,
  UrlField,
  SectionHeader,
  Instruction,
  CheckboxField,
  RadioField,
  SelectField,
  TextareaField,
  DateField,
  TimePickerField,
  FileField,
  RichTextInstructionField,
  StudentSearchField,
  TeacherSearchField,
  PreviousReportButton,
  WorksheetSearchField,
  DocumentLinkField
};

interface FieldComponentsMap {
  [key: string]: React.ComponentType<any>;
}

export const fieldComponents: FieldComponentsMap = {
  text: TextField,
  email: EmailField,
  url: UrlField,
  section_header: SectionHeader,
  instruction: Instruction,
  rich_text_instruction: RichTextInstructionField,
  checkbox: CheckboxField,
  radio: RadioField,
  select: SelectField,
  textarea: TextareaField,
  date: DateField,
  time_picker: TimePickerField,
  file: FileField,
  student_search: StudentSearchField,
  teacher_search: TeacherSearchField,
  previous_report_button: PreviousReportButton,
  worksheet_search: WorksheetSearchField,
  document_link: DocumentLinkField,
};
